import NewBookingHotel from "./NewBookingHotel";

export default NewBookingHotel;
